<template>
	<div class="pk-body-bg">
		<div v-if="!info.name"><van-empty description="暂无医院简介" /></div>
		<div v-else>
			<!-- 头部 -->
			<van-row class="div_header">
				<van-row>
					<van-col span="7">
						<viewer><img radius="8px" class="div_header_image" fit="cover" v-real-img="img_Prefix + info.picture" /></viewer>
					</van-col>
					<van-col span="17">
						<van-row style="padding: 10px 0px;">
							<van-col span="24" class="div_header_name">{{ info.name }}</van-col>
						</van-row>
						<van-row v-if="info.address">
							<van-col span="21">
								<div class="div_header_address">{{ info.address }}</div>
							</van-col>
							<!-- 
							<van-col span="3">
								<van-image width="30" height="30" fit="cover" :src="yiyImg" />
							</van-col>
							 -->
						</van-row>
					</van-col>
				</van-row>
			</van-row>
			<!-- 联系电话 -->
			<van-row class="div_conent_border" v-for="(item, id) of phonelist" :key="id" v-if="phonelist.length != 0">
				<van-col span="5" class="div_conent_title" v-if="id == 0">电　　话</van-col>
				<van-col span="5" v-else></van-col>
				<van-col span="7" class="div_conent_value" style="color: gray;">
					<a :href="'tel:' + item" style="color: gray;">{{ item }}</a>
				</van-col>
				<van-col span="2">
					<a :href="'tel:' + item" style="color: gray;"><van-image width="30" height="30" fit="cover" :src="linkPhoneImg" /></a>
				</van-col>
			</van-row>
			<!-- 官网地址 -->
			<van-row v-if="info.website" style="padding: 10px 20px;border-bottom: 1px solid gainsboro;"
				@click="towebsite">
				<van-col span="5" style="font-size: 14px;line-height: 30px;font-weight: bold;">官　　网</van-col>
				<van-col span="19" style="font-size: 14px;line-height: 30px;color: #1989fa;">{{ info.website }}
				</van-col>
			</van-row>
			<!-- 交通路线 -->
			<van-row v-if="info.traffic" style="padding: 10px 20px;border-bottom: 1px solid gainsboro;">
				<van-col span="5" style="font-size: 14px;line-height: 30px;font-weight: bold;">交通路线</van-col>
				<van-col span="19" style="font-size: 14px;line-height: 30px;">{{ info.traffic }}</van-col>
			</van-row>
			<!-- 医院介绍 -->
			<van-row align="left" style="padding-top: 10px;" v-if="info.profile">
				<van-col span="1">
					<div class="div_title_icon"></div>
				</van-col>
				<van-col span="23">
					<div class="div_title_value">医院介绍</div>
				</van-col>
			</van-row>
			<div style="padding: 10px;font-size: 14px;letter-spacing: 1.5px;line-height: 2;color: #646566;" v-html="info.profile"></div>
		</div>

	</div>
</template>

<script>
import { getHispitalInfo } from '@/api/query';
export default {
	components: {},
	data() {
		return {
			info: '',
			yiyImg: require('@assets/images/yiydh.png'),
			linkPhoneImg: require('@assets/images/yiylxdh.png'),
			phonelist: [],
			img_Prefix: process.env.VUE_APP_IMG_BASEURL, //线上图片的前缀
			gaode: process.env.VUE_APP_GAODE_PREFIX, //高德地图请求的前缀
		};
	},
	mounted() {
		getHispitalInfo().then(res => {
			if (res.success) {
				this.info = res.result;
				if (this.info.linkPhone.trim().length != 0) {
					this.phonelist = this.info.linkPhone.split('；');
				}
			}
		});
	},
	created() {},

	methods: {
		toAddress() {
			location.href = this.gaode;
		},
		towebsite() {
			location.href = this.info.website;
		}
	}
};
</script>

<style scoped>
.div_header {
	padding: 10px;
	border-bottom: 1px solid gainsboro;
}
.div_header_image {
	width: 80px;
	height: 80px;
	border-radius: 8px;
}
.div_header_name {
	font-size: 18px;
	font-weight: bold;
}
.div_header_address {
	color: gray;
	font-size: 14px;
	line-height: 20px;
	height: 60px;
	overflow-y: auto;
	overflow-x: hidden;
}
.div_conent_border {
	padding: 4px 20px;
	border-bottom: 1px solid gainsboro;
}
.div_conent_title {
	font-weight: bold;
	font-size: 14px;
	line-height: 30px;
}
.div_conent_value {
	font-size: 14px;
	height: 30px;
	line-height: 30px;
}
.div_title_icon {
	margin-top: 6px;
	margin-left: 10px;
	width: 5px;
	height: 18px;
	background-color: #0ec9ac;
}
.div_title_value {
	font-size: 14px;
	margin: 5px;
	font-weight: bold;
}
</style>
